import React from 'react'
import User from "../../models/User";
import {useMutation} from '@tanstack/react-query';
import {Img} from "react-image";
import AdminListView from "./components/AdminListView";
import LoadingSpinner from "../../components/LoadingSpinner";
import Modal from "../../components/Modal";
import TalentHRAssessmentModal from "./components/TalentHRAssessmentModal";
import {Link} from "react-router-dom";
import UserImageCircle from "../../components/UserImageCircle";
import AssessmentModal from "./components/AssessmentModal";
import {useAPI} from "../../config/API";
import ApproveProfileModal from './components/ApproveProfileModal';
import {Badge} from "antd";
import ApproveVideoInterviewsModal from "./components/ApproveVideoInterviewsModal";


export default class TalentManagerUsersList extends AdminListView {
    static path = '/manager/talent-vetting';

    static modelClass() {
        return User
    };
    static FailedEventName = 'Talent@FetchForTalentManagerFailed';
    static SuccessEventName = 'Talent@FetchForTalentManagerUpdated';
    static modelName = 'Talent User';
    static searchPlaceholder = 'Search by name, team, skill, role, or project interests'
    static tableClass = "talent-manager-talent-table"

    static statusOptions() {
        let statuses = User?.talentStatusFlatLookup();
        let invalidStatuses = ['Unregistered'];
        statuses = TB.filter(statuses, status => !invalidStatuses.includes(status.value));
        return statuses
    }

    static events() {
        let pageEvents = super.events();


        return {
            ...pageEvents,
            "Talent@TalentVettingUpdate": async (component, talent) => {
                let models = TB.tryArray(component.state.models);

                if (models?.length) {
                    // Find item index using _.findIndex
                    let matchIndex = TB.findIndex(models, ['id', talent.id]);

                    if (matchIndex > -1) {
                        // Replace talent at index using native splice
                        models.splice(matchIndex, 1, talent);
                        return component.promisedState({ models })
                    }

                }
            }
        }
    }

    static FetchAllRequest() {
        return User?.FetchAllForTalentManagerRequest;
    }

    async fetchResultsForParams(params, refresh) {
        return User.fetchAllForTalentManager(
            params, true
        );
    };

    constructor(props) {
        super(props);
        this.hrModalRef = React.createRef();
        this.capModalRef = React.createRef();

        this.state = {
            ...this.state,
            sortBy: 'applied_at',
            sortDir: 'desc',
        }
    }
    // renderHeader() {
    //     return <TalentManagerUsersStats/>
    // }

    listDetails(talent) {
        return (
            <tr key={`talent-${talent.id}`} className="talent-manager-user-row">
                <td>
                    <Img
                        loader={(
                            <div
                                className="img-fluid img-loader">
                                <LoadingSpinner/>
                            </div>
                        )}
                        unloader={<UserImageCircle user={talent} hideTooltip={true} size={55}/>}
                        src={talent.image_path}
                        className="img-grayscale img-fluid"/>
                </td>
                <td>
                    <div className="user-info-details">
                        <p className="text-xxs line-clamp-1 text-ellipsis"><b>Name: </b>{talent.fullName()}</p>

                        <p className="text-xxs line-clamp-1 text-ellipsis">
                            <b>Job Title: </b>{talent.job_title ? TB.truncate(
                            TB.capitalize(talent.job_title), {length: 50}
                        ) : 'N/A'}
                        </p>


                        <p className="text-xxs line-clamp-2 text-ellipsis">
                            <b>Email: </b>{talent.email ? (
                            <a href={`mailto:${talent.email}`} target="_blank">{talent.email}</a>
                        ) : 'N/A'
                        }
                        </p>
                        {talent.phone && (
                            <p className="text-xxs line-clamp-1 text-ellipsis">
                                <b>Phone: </b>{talent.phone ? (
                                <a href={`tel:${talent.phone}`} target="_blank">{talent.phoneNumber()}</a>
                            ) : 'N/A'}
                            </p>
                        )}

                    </div>
                </td>

                <td className="location">
                    <div className="w-24 relative overflow-hidden">
                        <p className="line-clamp-2 overflow-ellipsis">
                            {talent.location ? <span>
                                {talent.location.city}{!!talent.location.state && `, ${talent.location.state}`}
                            </span> : 'N/A'}
                        </p>
                    </div>
                </td>
                <td className="registered-at">
                    <p>{talent.applied_at ? TB.moment(talent.applied_at).format('ll') : "N/A"}</p>

                    <InviteAndRejectButtons talent={talent}/>
                </td>
                <td className="status">
                    <div className="flex flex-row items-center justify-center m-auto">

                        <Badge count={User.labelForStatus(talent.status)}
                               color={User.colorForStatus(talent.status)}/>

                    </div>
                </td>

                {/*<td className="skills"></td>*/}

                {/*<td className="project-interests"></td>*/}
                {/*<td className="industries"></td>*/}
                <td className="hr-assessment">
                    <div className="align-middle flex flex-col justify-between">
                        <div className="flex flex-row items-center justify-center mx-auto mb-3.5">
                            <div className="h-2.5"/>
                        </div>
                        <div className="interview-assessment-actions">
                            <p>
                                <span className="whitespace-no-wrap">
                                    Questions Submitted:
                                </span>
                                <span className="font-semibold">
                                    <span className="text-info">
                                        {talent.talent_video_interviews_count || 0}
                                    </span>
                                    <span>
                                        /{laravel.talent_video_interview_steps?.length}
                                    </span>
                                </span>
                            </p>
                            <p>
                                <span className="whitespace-no-wrap">
                                    Visible In Profile:
                                </span>
                                <span className="font-semibold whitespace-no-wrap">
                                    {talent.public_talent_video_interviews_count || 0}
                                    <span>
                                        /{laravel.talent_video_interview_steps?.length}
                                    </span>
                                </span>
                            </p>
                            {talent.pending_approval_talent_video_interviews_count > 0 && (
                                <p>
                                    <span className="whitespace-no-wrap text-danger">
                                        Pending Approval:
                                    </span>
                                    <span className="font-semibold text-danger whitespace-no-wrap">
                                        {talent.pending_approval_talent_video_interviews_count || 0}
                                    </span>
                                </p>
                            )}
                            <div className="flex flex-row gap-3 items-center justify-center">
                                {/*{talent.talent_video_interviews?.length && (*/}
                                <ApproveVideoInterviewsModal talent={talent}/>
                                {/*)}*/}
                            </div>
                        </div>
                    </div>
                </td>
                <td className="hr-assessment">
                    <div className="flex flex-row items-center justify-center mx-auto mb-3.5">

                        <Badge
                            count={talent.rejected_at ? 'Rejected' : talent.managerInterview().applicationAssessmentStatus()}
                            color={talent.rejected_at ? TB.config('color.danger-dark') : talent.managerInterview().applicationAssessmentColor()}/>
                    </div>
                    <div className="interview-assessment-actions">
                        <p>
                            <span>
                                HR:
                            </span>
                            {talent.managerInterview().hrAssessmentStatus()}
                        </p>
                        <p>
                            <span>
                                Capability:
                            </span>
                            {talent.managerInterview().capAssessmentStatus()}
                        </p>
                        <div className="flex flex-row mt-auto gap-3 items-center justify-evenly">
                            <button className="btn btn-link btn-link-primary px-0 flex-1" onClick={async () => {
                                await this.promisedState({hrAssessment: talent})

                                await TB.wait(100);

                                this.hrModalRef.current.showModal({title: `HR Assessment for ${talent.fullName()}`});
                            }}>
                                {talent.managerInterview().hasHRStatus() ? 'View HR' : 'Start HR'}
                            </button>
                            <button className="btn btn-link btn-link-primary px-0 flex-1" onClick={async () => {
                                await this.promisedState({capAssessment: talent})

                                // await TB.wait(100);

                                // this.capModalRef.current.showModal({title: `Capability Assessment for ${talent.fullName()}`});
                            }}>
                                {talent.managerInterview().hasCapabilityStatus() ? 'View Capability' : 'Start Capability'}
                            </button>
                        </div>
                    </div>
                </td>

                <td className="hr-assessment">
                    <div className="align-middle flex flex-col justify-between">
                        <div className="flex flex-row items-center justify-center mx-auto mb-3.5">

                            <Badge count={talent.profileApprovalStatus()}
                                   color={talent.profileApprovalStatusColor()}/>
                        </div>
                        <div className="interview-assessment-actions">
                            <div className="flex flex-row gap-3 items-center justify-center">
                                <Link target="_blank" to={`/talent-profiles/${talent.id}`}
                                      className="btn btn-link btn-link-primary px-0 flex-1 mt-0">
                                    View Profile
                                </Link>
                                <ApproveProfileModal canApprove={talent.canViewClientProfile()} talent={talent}/>
                            </div>
                        </div>
                    </div>
                </td>
                {/*<td className="hr-assessment">*/}
                {/*    {talent.managerInterview()?.hrAssessmentDetail(async () => {*/}
                {/*        await this.promisedState({ hrAssessment: talent })*/}

                {/*        await TB.wait(100);*/}

                {/*        this.hrModalRef.current.showModal({ title: `HR Assessment for ${talent.fullName()}` });*/}
                {/*    })}*/}
                {/*</td>*/}

                {/*<td className="capability-assessment">*/}

                {/*    {talent.managerInterview()?.capAssessmentDetail(async () => {*/}
                {/*        await this.promisedState({ capAssessment: talent })*/}

                {/*        // await TB.wait(100);*/}

                {/*        // this.capModalRef.current.showModal({title: `Capability Assessment for ${talent.fullName()}`});*/}
                {/*    })}*/}
                {/*</td>*/}

            </tr>
        )
    }

    listHeaders() {

        return [
            "",
            "Info",
            "Location",
            // "Registered At",
            this.sortedHeader("Applied At", 'applied_at'),
            "Marketplace Status",
            // "Roles",
            // "Skills",
            // "Project Interests",
            // "Industries",
            "Video Interviews",
            "Application Status",
            "Profile Status",
            // "Assessment"
        ]
    }

    renderListFooter() {
        return (
            <div>
                <Modal ref={this.hrModalRef}
                       modalClass={"hr-assessment-modal"}
                       onCloseAction={() => {
                           this.setState({hrAssessment: null})
                       }}>
                    {this.state.hrAssessment && (
                        <TalentHRAssessmentModal
                            talent={this.state.hrAssessment}
                            requestScroll={() => this.hrModalRef.current.scrollTop()}
                            onClose={async (callback, shouldRefresh = false) => {

                                await this.modalRef.current.hideModal();

                                if (shouldRefresh) {
                                    this.setState({isLoading: true})

                                    await TB.wait(250);

                                    await this.fetchResultsForListView();
                                }

                                if (callback) {
                                    await TB.wait(250);
                                    await callback();
                                }
                            }}
                        />
                    )}

                </Modal>

                {/*{
                    TODO Replace HR Assessment With Updated Assessment Component
                }*/}
                {this.state.capAssessment && (
                    <AssessmentModal
                        type={"capability"}
                        talentId={this.state.capAssessment?.id}
                        isDisabled={false} onClose={() => this.setState({ capAssessment: null })} />
                )}
                {/*<Modal ref={this.capModalRef}*/}
                {/*       modalClass={"hr-assessment-modal"}*/}
                {/*       onCloseAction={() => {*/}
                {/*           this.setState({assessment: null})*/}
                {/*       }}>*/}
                {/*    {this.state.assessment && (*/}
                {/*        <TalentCapabilityAssessmentModal*/}
                {/*            talent={this.state.assessment}*/}
                {/*            requestScroll={() => this.capModalRef.current.scrollTop()}*/}
                {/*            onClose={async(callback, shouldRefresh = false) => {*/}

                {/*                await this.modalRef.current.hideModal();*/}

                {/*                if (shouldRefresh)*/}
                {/*                {*/}
                {/*                    this.setState({isLoading: true})*/}

                {/*                    await TB.wait(250);*/}

                {/*                    await this.fetchResultsForListView();*/}
                {/*                }*/}

                {/*                if (callback) {*/}
                {/*                    await TB.wait(250);*/}
                {/*                    await callback();*/}
                {/*                }*/}
                {/*            }}*/}
                {/*        />*/}
                {/*    )}*/}

                {/*</Modal>*/}
            </div>
        )
    }
}

const InviteAndRejectButtons = ({ talent }) => {
    const inviteToVettingCall = useMutation(['inviteToVettingCall', parseInt(talent.id)],
        (props) => User.updateTalentFromManager(props.talentId, { talent_application_review_requested_at: new Date() }), {
        onError: (e) => {
            return TB.showServerErrorToast()
        },
        onSuccess: async (result) => {
            TB.toast('Talent invited');
        }
    }
    )

    const rejectApplication = useMutation(['rejectApplication', parseInt(talent.id)],
        (props) => User.updateTalentFromManager(props.talentId, { rejected_at: new Date() }), {
        onError: (e) => {
            return TB.showServerErrorToast()
        },
        onSuccess: async (result) => {
            TB.toast('Talent rejected');
        }
    }
    )

    if (talent.rejected_at || talent.is_active) return null;

    return (
        <div className="">

            {!!talent.talent_application_review_requested_at ? (
                <div className="pt-2">
                    <p className="font-bold">Vetting invite sent:</p>
                    <p>{TB.moment(talent.talent_application_review_requested_at).format('ll')}</p>
                </div>
            ) : (
                <button
                    type="button"
                    disabled={!!talent.talent_application_review_requested_at || inviteToVettingCall.isLoading}
                    className="btn btn-primary btn-xs my-2 w-ful text-[9px]"
                    onClick={async () => {
                        const confirm = await TB.alert(
                            'success',
                            'Invite to Vetting Call',
                            'We\'ll send over an invite for vetting',
                            [{ title: 'Invite to call' }, { title: 'Cancel' }],
                        )

                        if (confirm) {
                            inviteToVettingCall.mutateAsync({ talentId: talent.id })
                        }
                    }}
                >
                    Invite to Vetting Call
                </button>
            )}

            <button
                type="button"
                disabled={!!talent.rejected_at || rejectApplication.isLoading}
                className="btn btn-dark btn-xs my-2 w-ful text-[9px]"
                onClick={async () => {
                    const confirm = await TB.alert(
                        'warning',
                        'Are you sure?',
                        'Are you sure you want to reject this application?',
                        [{ title: 'Yes, reject' }, { title: 'Cancel' }],
                    )

                    if (confirm) {
                        console.log('SUBMIT REJECTION HERE')
                        rejectApplication.mutateAsync({ talentId: talent.id })
                    }
                }}
            >
                Reject Application
            </button>
        </div>
    )
}


const TalentManagerUsersStats = (props) => {

    const {
        data,
        isFetching: isLoading,
        error,
        refetch
    } = useAPI(['fetchTalentUserStatsForTalentManager'], {
        retry: false,
        onSuccess: (rep) => {
            console.log('onSuccess', rep)
        }
    })
    return (
        <React.Fragment>
            <div className="flex flex-row items-center gap-5 justify-between mt-5">
                {!isLoading && Object.keys(data)?.length > 0 && TB.map(data, (count, label) => (
                    <p className="text-xs font-semibold" key={`stat-${label}`}>
                        <span className="font-semibold">
                            {label}:
                        </span>
                        &nbsp;
                        &nbsp;
                        <span className="text-secondary">{count || 0} Total</span>
                    </p>
                ))}
            </div>

            <hr />
        </React.Fragment>
    )
};